/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { IntegrationEnvironment } from "./IntegrationEnvironment";
import {
  IntegrationEnvironmentFromJSON,
  IntegrationEnvironmentFromJSONTyped,
  IntegrationEnvironmentToJSON,
  IntegrationEnvironmentToJSONTyped,
} from "./IntegrationEnvironment";

/**
 *
 * @export
 * @interface UpdateNetSuiteIntegrationRequest
 */
export interface UpdateNetSuiteIntegrationRequest {
  /**
   *
   * @type {string}
   * @memberof UpdateNetSuiteIntegrationRequest
   */
  integrationId: string;
  /**
   *
   * @type {string}
   * @memberof UpdateNetSuiteIntegrationRequest
   */
  name: string;
  /**
   *
   * @type {IntegrationEnvironment}
   * @memberof UpdateNetSuiteIntegrationRequest
   */
  environment: IntegrationEnvironment;
  /**
   *
   * @type {boolean}
   * @memberof UpdateNetSuiteIntegrationRequest
   */
  enabled: boolean;
  /**
   *
   * @type {string}
   * @memberof UpdateNetSuiteIntegrationRequest
   */
  accountId: string;
}

/**
 * Check if a given object implements the UpdateNetSuiteIntegrationRequest interface.
 */
export function instanceOfUpdateNetSuiteIntegrationRequest(
  value: object,
): value is UpdateNetSuiteIntegrationRequest {
  if (!("integrationId" in value) || value["integrationId"] === undefined)
    return false;
  if (!("name" in value) || value["name"] === undefined) return false;
  if (!("environment" in value) || value["environment"] === undefined)
    return false;
  if (!("enabled" in value) || value["enabled"] === undefined) return false;
  if (!("accountId" in value) || value["accountId"] === undefined) return false;
  return true;
}

export function UpdateNetSuiteIntegrationRequestFromJSON(
  json: any,
): UpdateNetSuiteIntegrationRequest {
  return UpdateNetSuiteIntegrationRequestFromJSONTyped(json, false);
}

export function UpdateNetSuiteIntegrationRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): UpdateNetSuiteIntegrationRequest {
  if (json == null) {
    return json;
  }
  return {
    integrationId: json["integrationId"],
    name: json["name"],
    environment: IntegrationEnvironmentFromJSON(json["environment"]),
    enabled: json["enabled"],
    accountId: json["accountId"],
  };
}

export function UpdateNetSuiteIntegrationRequestToJSON(
  json: any,
): UpdateNetSuiteIntegrationRequest {
  return UpdateNetSuiteIntegrationRequestToJSONTyped(json, false);
}

export function UpdateNetSuiteIntegrationRequestToJSONTyped(
  value?: UpdateNetSuiteIntegrationRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    integrationId: value["integrationId"],
    name: value["name"],
    environment: IntegrationEnvironmentToJSON(value["environment"]),
    enabled: value["enabled"],
    accountId: value["accountId"],
  };
}
